import { LuSearch } from "@/Components/Icons/Icons.jsx";
import { data } from "react-router";
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "exportContainerNo",
            label: "Container No",
            component: "text-field",
            required: true,
          },
          {
            name: "exportContainerType",
            label: "Type",
            component: "dropdown",
            endIconName: "LuChevronDown",
            options: [
              { label: "20 Bulk", value: "20 Bulk" },
              { label: "20 Standard Dry", value: "20 Standard Dry" },
              { label: "20 Flat Rack", value: "20 Flat Rack" },
              {
                label: "20 Collapsible Flat Rack",
                value: "20 Collapsible Flat Rack",
              },
              { label: "20 Reefer", value: "20 Reefer" },
              { label: "20 Tank", value: "20 Tank" },
              { label: "20 Open Top", value: "20 Open Top" },
              { label: "20 Hard Top", value: "20 Hard Top" },
              { label: "20 Platform", value: "20 Platform" },
              { label: "40 Standard Dry", value: "40 Standard Dry" },
              { label: "40 Flat Rack", value: "40 Flat Rack" },
              {
                label: "40 Collapsible Flat Rack",
                value: "40 Collapsible Flat Rack",
              },
              { label: "40 Reefer", value: "40 Reefer" },
              { label: "40 Tank", value: "40 Tank" },
              { label: "40 Open Top", value: "40 Open Top" },
              { label: "40 Hard Top", value: "40 Hard Top" },
              { label: "40 High Cube", value: "40 High Cube" },
              { label: "40 Reefer High Cube", value: "40 Reefer High Cube" },
              { label: "40 Platform", value: "40 Platform" },
            ],
            placeholder: "20 Bulk",
          },
        ],
        row2: [
          {
            name: "exportContainerSealNo",
            label: "Seal No",
            width: "50%",
            component: "text-field",
          },
          {
            name: "exportContainerSealDate",
            label: "Seal Date",
            component: "dateselector",
            width: "50%",
          },
        ],
        row3: [
          {
            name: "exportContainerMoveDocType",
            label: "Move Doc.Type",
            component: "text-field",
          },
          {
            name: "exportContainerMoveDocNo",
            label: "Move Doc.No",
            component: "text-field",
          },
        ],
        row4: [
          {
            name: "exportContainerPktsStuffed",
            label: "Pkts Stuffed",
            component: "text-field",
            width: "52%",
          },
          {
            name: "exportContainerGrossweight",
            label: "Gross Weight",
            component: "text-field",
            width: "30%",
            dataType: "int"
          },
          {
            name: "exportContainerGrossweightUnit",
            component: "text-field",
            width: "20%",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getVolume",
          },
        ],
        row5: [
          {
            name: "exportContainerSealType",
            label: "Seal Type",
            component: "dropdown",
            width: "52%",
            endIconName: "LuChevronDown",
            options: [
              { label: "BTSL - Bottle Seal", value: "BTSL - Bottle Seal" },
              {
                label: "ESEAL - Electronic Seal",
                value: "ESEAL - Electronic Seal",
              },
              {
                label: "RFID - Radio frequency Identifier",
                value: "RFID - Radio frequency Identifier",
              },
            ],
            placeholder: "BTSL - Bottle Seal",
          },
          {
            name: "exportContainerSealDeviceId",
            label: "Seal Device ID",
            component: "text-field",
            width: "30%",
          },
          {
            name: "PackingDetails",
            label: "Packing Details",
            component: "outlinebutton",
            width: "20%",
            sx: { mt: 4 },
            action: "openSubDialog",
            subComponent: "PackageDetails",  // 👈 what to open
          },
        ],
        row6: [
          {
            name: "exportContainerLocation",
            label: "Location",
            component: "text-field",
            width: "52%",
          },
          {
            name: "exportContainerGrWtTrWt",
            label: "Gr-Wt+Tr-Wt",
            component: "text-field",
            width: "30%",
            dataType: "int"
          },
          {
            name: "exportContainerGrWtTrWtUnit",
            component: "text-field",
            width: "20%",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getVolume",
          },
        ],
      },
    },
  ],
};
